import { render, staticRenderFns } from "./ot-expansion-panel-wrapper.vue?vue&type=template&id=f599474e&scoped=true&"
import script from "./ot-expansion-panel-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-expansion-panel-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-expansion-panel-wrapper.vue?vue&type=style&index=0&id=f599474e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f599474e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
